import { useFieldContext } from '@/shared/lib/form';
import { Field } from '@noorden-insurtech/alba-design-system';
import { Mask, withMask } from 'use-mask-input';
import { MaskPresetKey, resolveMaskWithOptions } from '@/shared/constants';

interface InputFieldProps {
  label: string;
  type: string;
  placeholder: string;
  required: boolean;
  helperText: string;
  disabled?: boolean;
  maxLength?: number;
  mask?: Mask | MaskPresetKey;
  /** Converte o que é digitado/colado para minúsculas (ex.: e-mail de login). */
  lowercase?: boolean;
}

export function InputField({
  label,
  type,
  placeholder,
  required,
  helperText,
  disabled,
  maxLength,
  mask,
  lowercase,
}: InputFieldProps) {
  const field = useFieldContext<string>();
  const showError =
    !field.state.meta.isValid &&
    (field.state.meta.isTouched || field.form.state.isSubmitted);

  const [resolvedMask, resolvedMaskOptions] = mask
    ? resolveMaskWithOptions(mask)
    : [undefined, undefined];

  return (
    <Field.Root invalid={showError} required={required} disabled={disabled}>
      <Field.Label
        htmlFor={field.name}
        className='text-alba-black-500'
      >
        {label}
      </Field.Label>
      <Field.Input
        ref={resolvedMask ? withMask(resolvedMask, resolvedMaskOptions) : undefined}
        id={field.name}
        type={type}
        value={field.state.value}
        onChange={e =>
          field.handleChange(
            lowercase ? e.target.value.toLowerCase() : e.target.value
          )
        }
        onBlur={field.handleBlur}
        placeholder={placeholder}
        maxLength={maxLength}
      />
      {helperText && <Field.HelperText>{helperText}</Field.HelperText>}
      {showError && (
        <Field.ErrorText>
          {field.state.meta.errors?.map(err => err.message).join(',')}
        </Field.ErrorText>
      )}
    </Field.Root>
  );
}
